/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import ReactVideoPreview from '../components/VideoPreview/VideoPreview'

export class VideoPreview extends HTMLElement {
  connectedCallback () {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    const name = this.getAttribute('name')
    const img = this.getAttribute('img')
    const src = this.getAttribute('src')
    const loopEnd = parseInt(this.getAttribute('loopEnd') ?? '6', 10)
    const width = this.getAttribute('width')
    const height = this.getAttribute('height')
    const label = this.getAttribute('label')   // label="false" hides the name overlay (e.g. when the name is printed below the tile)
    mountPoint.setAttribute('width', width ?? "240px")
    mountPoint.setAttribute('height', height ?? "180px")
    mountPoint.style['display'] = 'inline-block'
    //const root = ReactDOM.createRoot(mountPoint)
    //root.render(<ReactVideoPreview name={name} src={src} loopEnd={loopEnd} width={width} height={height} />)
    createRoot(mountPoint).render(<ReactVideoPreview name={name ?? 'Gast'} img={img ?? ''} src={src ?? ''} loopEnd={loopEnd ?? 6} width={width ?? '240px'} height={height ?? '120px'} label={label === 'false' ? false : undefined} />)
  }
}
customElements.define('video-preview', VideoPreview)
